module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('cover-image', {
    attrs: {
      "src": 'static/bg-blog.jpg',
      "title": 'Blog',
      "description": ''
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container content"
  }, [(_vm.articles === null) ? _c('div', {
    staticClass: "empty row"
  }, [_vm._v("There are no articles yet")]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, _vm._l((_vm.articles), function(article) {
    return _c('article-card', {
      key: article,
      attrs: {
        "article": article,
        "orientation": 'left',
        "published": _vm.checkArticlePublishDate(article.publishDate)
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 offset-md-1 sidebar"
  }, [_c('h3', {
    staticClass: "row section-title"
  })])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b8d662a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/BlogView.vue
// module id = 500
// module chunks = 1